const CARD_STOP_OFFSET_PX = 64;

export function getMobileStickyOffset({
  baseStickyOffset,
  index,
  offsetMobileScrollTop,
}: {
  baseStickyOffset: string;
  index: number;
  offsetMobileScrollTop?: boolean;
}) {
  if (!offsetMobileScrollTop) {
    return baseStickyOffset;
  }

  return `calc(${baseStickyOffset} + ${index * CARD_STOP_OFFSET_PX}px)`;
}
